import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { produce } from 'immer';
import { AnyObject } from '@/types/common';

export type CommonStore = {
  isOnboarding: boolean;
  fromIntegration: string | null;
  integrationData: Record<string, AnyObject>;
  isLoggingOut: boolean;
  isMaintenance: boolean;
  setIsOnboarding: (isOnboarding: boolean) => void;
  setFromIntegration: (fromIntegration: string | null) => void;
  setIntegrationData: (name: string, data: AnyObject) => void;
  setIsLoggingOut: (isLoggingOut: boolean) => void;
  setMaintenance: (maintenance: boolean) => void;
};

export const useCommonStore = create<CommonStore>()(
  devtools(
    persist(
      (set) => ({
        isOnboarding: false,
        fromIntegration: null,
        isLoggingOut: false,
        integrationData: {},
        isMaintenance: false,
        setMaintenance: (maintenance: boolean) => {
          set(
            produce((state: CommonStore): void => {
              state.isMaintenance = maintenance;
            })
          );
        },
        setIsOnboarding: (isOnboarding: boolean) => {
          set(
            produce((state: CommonStore): void => {
              state.isOnboarding = isOnboarding;
            })
          );
        },
        setFromIntegration: (fromIntegration: string | null) => {
          set(
            produce((state: CommonStore): void => {
              state.fromIntegration = fromIntegration;
            })
          );
        },
        setIntegrationData: (name: string, data: AnyObject) => {
          set(
            produce((state: CommonStore): void => {
              state.integrationData[name] = data;
            })
          );
        },
        setIsLoggingOut: (isLoggingOut: boolean) => {
          set(
            produce((state: CommonStore): void => {
              state.isLoggingOut = isLoggingOut;
            })
          );
        },
      }),
      {
        name: 'common',
        storage: createJSONStorage(() => sessionStorage),
        partialize: (state) => ({
          fromIntegration: state.fromIntegration,
          integrationData: state.integrationData,
        }),
      }
    )
  )
);
